import { useTranslation } from 'react-i18next';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';
import { useTrialDays } from '@/hooks/useTrialDays';

export const FAQ = () => {
  const { t } = useTranslation();
  const { trialDays } = useTrialDays();

  const faqs = [
    {
      question: t('faq.q1.question'),
      answer: t('faq.q1.answer')
    },
    {
      question: t('faq.q2.question', { days: trialDays }),
      answer: t('faq.q2.answer', { days: trialDays })
    },
    {
      question: t('faq.q3.question'),
      answer: t('faq.q3.answer')
    },
    {
      question: t('faq.q4.question'),
      answer: t('faq.q4.answer')
    },
    {
      question: t('faq.q5.question'),
      answer: t('faq.q5.answer')
    },
    {
      question: t('faq.q6.question'),
      answer: t('faq.q6.answer')
    }
  ];

  return (
    <div className="mb-16 animate-fade-in">
      <div className="text-center mb-12">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-newsletter-primary/10 border border-newsletter-primary/20 mb-4">
          <HelpCircle className="w-4 h-4 text-newsletter-primary" />
          <span className="text-sm font-medium text-newsletter-primary">
            {t('faq.badge')}
          </span>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold">
          {t('faq.title')}
        </h2>
      </div>

      <div className="max-w-3xl mx-auto">
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="border border-newsletter-primary/20 rounded-xl px-6 bg-background/50 backdrop-blur-sm hover:border-newsletter-primary/40 transition-all duration-300"
            >
              <AccordionTrigger className="text-left font-semibold hover:text-newsletter-primary transition-colors py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};
